import {h, Fragment} from "preact"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"

import Toolbar from "./Toolbar"
import SelectedFilters from "./SelectedFilters"
import Products from "./Products"
import BottomToolbar from "./BottomToolbar"
import Skeleton from "./Skeleton"
import NoResults from "./NoResults"

export function SerpBody({ loading, foundProducts }) {
    return (foundProducts ? (
        <>
            <Toolbar />
            <SelectedFilters />
            <Products />
            <BottomToolbar />
        </> 
    ) : loading ? (
        <Skeleton />
    ) : (
        <NoResults />
    ))
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    return (foundProducts ? (
        <>
            <Toolbar />
            <SelectedFilters />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    ) : loading ? (
        <Skeleton />
    ) : (
        <NoResults />
    ))
}

// replace with following line to enable infinite scroll.
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
